import { SET_REGION_SEO_CONTENT } from './regionSeoContent.types';
export var setRegionSeoContent = function setRegionSeoContent(blocks) {
  return {
    type: SET_REGION_SEO_CONTENT,
    blocks: blocks
  };
};